export default __webpack_public_path__ + "static/media/Home-Green.a9daba38.svg";